import FontAwesome5 from '@expo/vector-icons/FontAwesome5';
import {
  responsiveFontSize,
  useResponsiveFontSize,
  useResponsiveHeight,
} from '@/components/Util/reactResponsiveDimensions';
import { useEffect } from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { View as AnimatableView } from 'react-native-animatable';
import { useExerciseRecord } from '@/hooks/useExerciseRecord';
import { PressableNeolexon } from '@/components/PressableNeolexon';

// Taken from github to simulate the column gap functionality in web css
const gap = 8;
export function SpeakingHeader({
  uniqueKey,
  currentExercise,
  timeoutSeconds,
  isVideoPlaying,
  handleIsRecording,
  handleIsAudioPlaying,
  selectedPerformance,
  abortPlayingRecording,
  isRecordingDisabled,
}) {
  const iconSize = useResponsiveFontSize(2.6);
  const marginVertical = useResponsiveHeight(1.1);

  const {
    isRecording,
    startRecording,
    stopRecording,
    playRecording,
    stopPlayingRecording,
    isPlaying,
    uri,
  } = useExerciseRecord(currentExercise, timeoutSeconds, uniqueKey);

  const styles = StyleSheet.create({
    container: {
      flexDirection: 'row',
      justifyContent: 'center',
      marginVertical,
      paddingHorizontal: gap / -2,
    },
    btn: {
      marginHorizontal: gap / 2,
      width: responsiveFontSize(6.2),
      height: responsiveFontSize(6.2),
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: Platform.OS === 'web' ? '50%' : 50,
      borderWidth: 1,
      borderColor: '#d3d3d3',
      backgroundColor: '#ffff',
    },
    disabledStyling: {
      opacity: 0.3,
    },
  });

  const handleStartRecording = () => {
    handleIsRecording(true);
    startRecording();
  };
  const handleStopRecording = () => {
    handleIsRecording(false);
    stopRecording(true);
  };

  const RecordingComponent = isRecording ? (
    <AnimatableView
      animation="fadeIn"
      easing="ease-out"
      iterationCount="infinite"
      direction="alternate"
      duration={800}
    >
      <PressableNeolexon
        onPress={handleStopRecording}
        disabled={isPlaying || isVideoPlaying || selectedPerformance !== 'none'}
        style={[
          styles.btn,
          (isPlaying || isVideoPlaying || selectedPerformance !== 'none') &&
            styles.disabledStyling,
        ]}
      >
        <FontAwesome5 name="microphone" size={iconSize} color="red" />
      </PressableNeolexon>
    </AnimatableView>
  ) : (
    <PressableNeolexon
      onPress={handleStartRecording}
      disabled={
        isPlaying ||
        isVideoPlaying ||
        selectedPerformance !== 'none' ||
        isRecordingDisabled
      }
      style={[
        styles.btn,
        (isPlaying ||
          isVideoPlaying ||
          selectedPerformance !== 'none' ||
          isRecordingDisabled) &&
          styles.disabledStyling,
      ]}
    >
      <FontAwesome5 name="microphone" size={iconSize} color="red" />
    </PressableNeolexon>
  );

  useEffect(() => {
    if (isPlaying) {
      handleIsAudioPlaying && handleIsAudioPlaying(true);
    } else {
      handleIsAudioPlaying && handleIsAudioPlaying(false);
    }
    handleIsRecording && handleIsRecording(false);
  }, [isPlaying]);

  useEffect(() => {
    if (!abortPlayingRecording) {
      return;
    }
    stopPlayingRecording();
  }, [abortPlayingRecording]);

  return (
    <View style={styles.container}>
      {RecordingComponent}
      <PressableNeolexon
        onPress={isPlaying ? stopPlayingRecording : playRecording}
        disabled={
          isRecording ||
          !uri ||
          isVideoPlaying ||
          selectedPerformance !== 'none'
        }
        style={[
          styles.btn,
          (isRecording ||
            !uri ||
            isVideoPlaying ||
            selectedPerformance !== 'none') &&
            styles.disabledStyling,
        ]}
      >
        <FontAwesome5
          name={isPlaying ? 'pause' : 'play'}
          size={iconSize}
          color="#3a3a3a"
        />
      </PressableNeolexon>
    </View>
  );
}
